import React, { useState } from "react";

const NavigationBar = ({ currentPage, setPage, totalPages }) => {
  window.addEventListener("load", function () {
    var titleBarHeight = document.querySelector(".title-bar").offsetHeight;
    var navigationBar = document.querySelector(".nav-bar");

    navigationBar.style.top = titleBarHeight + "px";
  });

  return (
    <div>
      <div className="title-bar">
        <h1 className="website-title">Synestia</h1>
        <div className="logo">
          <img src="Hotpot.png" alt="Logo" className="logo-image" />
        </div>
      </div>

      <div className="nav-bar">
        <button onClick={() => setPage(0)} disabled={currentPage === 0}>
          First
        </button>
        <button
          onClick={() => setPage((prevPage) => prevPage - 1)}
          disabled={currentPage === 0}
        >
          Prev
        </button>
        <button
          onClick={() => setPage((prevPage) => prevPage + 1)}
          disabled={currentPage === totalPages - 1}
        >
          Next
        </button>

        <button
          onClick={() => setPage(totalPages - 1)}
          disabled={currentPage === totalPages - 1}
        >
          Last
        </button>
      </div>
    </div>
  );
};

const ComicBookDisplay = () => {
  const [currentPage, setCurrentPage] = useState(0);

  const comicPages = [
    "../synestiawebsite/synestiawebsite-1.jpg",
    "../synestiawebsite/synestiawebsite-2.jpg",
    "../synestiawebsite/synestiawebsite-3.jpg",
    "../synestiawebsite/synestiawebsite-4.jpg",
    "../synestiawebsite/synestiawebsite-5.jpg",
    "../synestiawebsite/synestiawebsite-6.jpg",
    "../synestiawebsite/synestiawebsite-7.jpg",
    "../synestiawebsite/synestiawebsite-8.jpg",
    "../synestiawebsite/synestiawebsite-9.jpg",
    "../synestiawebsite/synestiawebsite-10.jpg",
    "../synestiawebsite/synestiawebsite-11.jpg",
    "../synestiawebsite/synestiawebsite-12.jpg",
    "../synestiawebsite/synestiawebsite-13.jpg",
    "../synestiawebsite/synestiawebsite-14.jpg",
    "../synestiawebsite/synestiawebsite-15.jpg",
    "../synestiawebsite/synestiawebsite-16.jpg",
    "../synestiawebsite/synestiawebsite-17.jpg",
    "../synestiawebsite/synestiawebsite-18.jpg",
    "../synestiawebsite/synestiawebsite-19.jpg",
    "../synestiawebsite/synestiawebsite-20.jpg",
    "../synestiawebsite/synestiawebsite-21.jpg",
    "../synestiawebsite/synestiawebsite-22.jpg",
    "../synestiawebsite/synestiawebsite-23.jpg",
    "../synestiawebsite/synestiawebsite-24.jpg",
    "../synestiawebsite/synestiawebsite-25.jpg",
    "../synestiawebsite/synestiawebsite-26.jpg",
    "../synestiawebsite/synestiawebsite-27.jpg",
    "../synestiawebsite/synestiawebsite-28.jpg",
    "../synestiawebsite/synestiawebsite-29.jpg",
    "../synestiawebsite/synestiawebsite-30.jpg",
    "../synestiawebsite/synestiawebsite-31.jpg",
    "../synestiawebsite/synestiawebsite-32.jpg"

    // Add more page URLs as needed
  ];

  const totalPages = comicPages.length;

  const setPage = (pageIndex) => {
    setCurrentPage(pageIndex);
  };

  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const handleCommentChange = (e) => {
    setNewComment(e.target.value);
  };

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    setComments([...comments, newComment]);
    setNewComment("");
  };

  return (
    <div className="comic-book-container">
      <NavigationBar
        currentPage={currentPage}
        setPage={setPage}
        totalPages={totalPages}
      />
      <div className="comic-page-container">
        <img src={comicPages[currentPage]} alt={`Page ${currentPage + 1}`} />
      </div>
      <div className="discussion-section">
        <h2 className="border-text">Discussion</h2>
        <div className="comment-list">
          {comments.map((comment, index) => (
            <div key={index} className="comment-box">
              {comment}
            </div>
          ))}
        </div>
        <form className="comment-form" onSubmit={handleCommentSubmit}>
          <textarea
            placeholder="Enter your comment"
            value={newComment}
            onChange={handleCommentChange}
          ></textarea>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ComicBookDisplay;
